import { TranslatedText } from "$src/domain/core/TranslatedText";

export enum InstallationType {
    None = 0,
    CompleteInstallation = 1,
    InstallationAssistance = 2,
}

export interface InstallationTypeValue {
    id: InstallationType;
    translations: TranslatedText[];
}